import isArray from 'lodash/isArray'
import isString from 'lodash/isString'
import { addMethod, AnySchema, array, ArraySchema, string, StringSchema } from 'yup'

import { getTextFromHTMLString, retrieveHtmlTextAndLength } from 'Shared/utils'

function arrayRequiredNotAllowEmpty<T extends AnySchema>(this: ArraySchema<T>, message?: string) {
	return this.test('required', message || '', (value) =>
		isArray(value) ? !!value.length : false
	)
}

function maxLengthHtmlString(this: StringSchema, maxLength: number, message?: string) {
	return this.test('maxHtmlString', message || '', (value) => {
		if (isString(value)) {
			return value.length <= maxLength
		}
		return true
	})
}

function maxLengthHtmlStringWithEscapes(this: StringSchema, maxLength: number, message?: string) {
	return this.test('maxHtmlStringWithEscapes', message || '', (value) => {
		if (isString(value)) {
			const { length } = retrieveHtmlTextAndLength(value)
			return length <= maxLength
		}
		return true
	})
}

function requiredHtmlString(this: StringSchema, message?: string) {
	return this.test('required', message || '', (value) => {
		if (isString(value)) {
			const text = getTextFromHTMLString(value)
			return text.trim().length > 0
		}
		return true
	})
}

export const addGlobalYupMethods = () => {
	addMethod(array, 'requiredArrayNotAllowEmpty', arrayRequiredNotAllowEmpty)
	addMethod(string, 'maxLengthHtmlString', maxLengthHtmlString)
	addMethod(string, 'requiredHtmlString', requiredHtmlString)
	addMethod(string, 'maxLengthHtmlStringWithEscapes', maxLengthHtmlStringWithEscapes)
}
